import { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useAuth, API } from '../App';
import axios from 'axios';

const ChannelSelector = ({ 
  value, 
  onChange, 
  showAllOption = true
}) => {
  const { user, token } = useAuth();
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchAccessibleChannels();
    }
  }, [token]);

  const fetchAccessibleChannels = async () => {
    try {
      const response = await axios.get(`${API}/channels/accessible`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const accessibleChannels = response.data.channels || [];
      setChannels(accessibleChannels);
      
      // Auto-select if only one channel
      if (accessibleChannels.length === 1 && !value) {
        onChange(accessibleChannels[0].id);
      }
    } catch (error) {
      console.error('Failed to fetch accessible channels:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="h-9 w-64 bg-muted animate-pulse rounded-md" data-testid="channel-selector-loading" />;
  }

  if (channels.length === 0) {
    return (
      <p className="text-sm text-muted-foreground" data-testid="no-channels-msg">
        No channels available
      </p>
    );
  }
  
  // Single channel: show static display (no dropdown needed)
  if (channels.length === 1 && !showAllOption) {
    return (
      <div className="flex items-center gap-2 text-sm font-medium" data-testid="channel-selector-single">
        <span className="text-green-600">&#x260E;</span>
        {channels[0].display_name || channels[0].phone_number}
      </div>
    );
  }

  return (
    <Select value={value || ''} onValueChange={onChange} data-testid="channel-selector">
      <SelectTrigger className="w-64" data-testid="channel-selector-trigger">
        <SelectValue placeholder="Select channel" />
      </SelectTrigger>
      <SelectContent>
        {showAllOption && channels.length > 1 && (
          <SelectItem value="all" data-testid="channel-option-all">All Channels</SelectItem>
        )}
        {channels.map((channel) => (
          <SelectItem 
            key={channel.id} 
            value={channel.id}
            data-testid={`channel-option-${channel.id}`}
          >
            {channel.display_name || channel.phone_number || channel.id}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ChannelSelector;
